export const settlementAgreement = [
  {
    value: 'Yes',
    label: 'Yes',
  },{
    value: 'No',
    label: 'No',
  },{
    value: 'Not sure',
    label: 'Not Sure',
  },
];
